export default {
  tuichushuliang: '退出数量',
  chiyoushuliang: '持有数量',
  chiyoujiazhi: '持有价值',
  bijia: '币价',
  mairushuliang: '买入数量',


}